import { useState, useEffect } from 'react';
import {
  checkAllocationWarnings,
  NA_VALUE,
} from '../components/CouncilMemberAllocation/allocationHelpers';
import { useAdminCollections } from '../../context/AdminCollections';
import { getNominationRoundYear } from '../../utils/getNominationRoundYear';

export const useAllocationWarnings = (allocations, groupedData) => {
  const [allocationWarnings, setAllocationWarnings] = useState({});
  const { coiDeclarationArray } = useAdminCollections();

  useEffect(() => {
    const newWarnings = {};
    const currentRound = getNominationRoundYear(new Date());

    groupedData.forEach((committee) => {
      committee.nominations.forEach((nomination) => {
        const allocation = allocations[nomination.nominationId];

        if (
          !allocation ||
          allocation.value === null ||
          allocation.value === undefined
        ) {
          newWarnings[nomination.nominationId] = [
            {
              type: 'unallocated',
            },
          ];
        } else if (allocation.value && allocation.value !== NA_VALUE) {
          const warnings = checkAllocationWarnings(
            nomination.nominationId,
            allocation.value,
            committee.committeeId,
            allocations,
            groupedData,
          );

          const hasDirectCOI = coiDeclarationArray?.some((declaration) => {
            const declaredUserId =
              declaration.attributes?.userId || declaration.userId;
            const declaredNominationId =
              declaration.attributes?.nominationId || declaration.nominationId;
            const declaredCandidateId =
              declaration.attributes?.candidateId || declaration.candidateId;
            const nominationRound =
              declaration.attributes?.nominationRound ||
              declaration.nominationRound;

            const coiTypes = declaration.attributes?.coiTypes?.data || [];
            const hasDirectCategory = coiTypes.some(
              (type) => type.attributes?.category === 'direct',
            );

            return (
              declaredUserId === allocation.value &&
              declaredNominationId === nomination.nominationId &&
              declaredCandidateId === nomination.candidateId &&
              nominationRound === currentRound &&
              hasDirectCategory
            );
          });

          const allWarnings = warnings || [];

          if (hasDirectCOI) {
            allWarnings.push({
              type: 'direct-coi',
              message: `${allocation.label} has declared a DIRECT conflict of interest with this candidate`,
              severity: 'danger',
              councilMemberName: allocation.label,
            });
          }

          if (allWarnings.length > 0) {
            newWarnings[nomination.nominationId] = allWarnings;
          }
        }
      });
    });

    setAllocationWarnings(newWarnings);
  }, [allocations, groupedData, coiDeclarationArray]);

  return allocationWarnings;
};
